import * as actionTypes from "../action";

const initialState = {
  ticketsLoader: false,
  deleteticketsLoading: false,
  ticketsData: [],
  addTicketsLoader: false,
  addTicketsData: [],
  ticketsUpdateLoader: false,
  ticketsDetailLoader: false,
  ticketsDetailData: {},
  ticketsCount: {},
  ticketLogLoader: false,
  ticketStatusUpdateLoader: false,
  ticketLogData: [],
};

const ticketsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TOTAL_TICKETS_COUNT:
      return { ...state, ticketsCount: action.payload };

    case actionTypes.GET_ALL_TICKET_LOADING:
      return { ...state, ticketsLoader: action.payload };

    case actionTypes.GET_ALL_TICKET_DATA:
      return { ...state, ticketsData: action.payload };

    case actionTypes.ADD_TICKET_LOADING:
      return { ...state, addTicketsLoader: action.payload };

    case actionTypes.ADD_TICKET_DATA:
      return { ...state, addTicketsData: action.payload };

    case actionTypes.DELETE_TICKET_LOADING:
      return { ...state, deleteticketsLoading: action.payload };

    case actionTypes.DELETE_TICKET_ID:
      return {
        ...state,
        ticketsData: [
          ...state.ticketsData.filter(
            (data) => data.id !== action.payload
          ),
        ],
      };


    case actionTypes.UPDATE_TICKET_LOADING:
      return { ...state, ticketsUpdateLoader: action.payload };

    case actionTypes.UPDATE_TICKET_STATUS_LOADING:
      return { ...state, ticketStatusUpdateLoader: action.payload };

    case actionTypes.UPDATE_TICKET_STATUS_DATA:
      return {
        ...state,
        ticketsData: state.ticketsData.map((data) =>
          data.ticket_id === action.payload.ticket_id
            ? {
                ...data,
                status: action.payload.status,
              }
            : data
        ),
      };

    // case actionTypes.UPDATE_TICKET_STATUS_LOADING:
    //   return { ...state, ticketStatusUpdateLoader: action.payload };

    case actionTypes.GET_TICKET_DETAIL_LOADING:
      return { ...state, ticketsDetailLoader: action.payload };

    case actionTypes.GET_TICKET_DETAIL_DATA:
      return {
        ...state,
        ticketsDetailData: action.payload,
      };

    case actionTypes.GET_ALL_TICKET_LOG_LOADING:
      return { ...state, ticketLogLoader: action.payload };

    case actionTypes.GET_ALL_TICKET_LOG_DATA:
      return { ...state, ticketLogData: action.payload };

    default:
      return state;
  }
};

export default ticketsReducer;
